import { useApp } from 'context/app-context'
import { Dispatch } from 'react'
import { ModalProps } from 'ui'

type ConfirmationHandler = (props: {
  onConfirm?: () => any
  onDismiss?: () => any
}) => any

const useAwaitConfirmation = (
  setLocalModal?: Dispatch<any>,
  modalProps?: Partial<ModalProps>,
) => {
  const { setModal: setAppModal, setModalProps: setAppModalProps } = useApp()

  return async (handler: ConfirmationHandler): Promise<null | 'dismiss'> => {
    return new Promise((resolve, reject) => {
      if (modalProps) {
        setAppModalProps(modalProps)
      }

      const setModal: Dispatch<any> = setLocalModal ?? setAppModal
      setModal(
        handler({
          onConfirm: () => {
            setModal(null)
            resolve(null)
          },
          onDismiss: () => {
            setModal(null)
            reject('dismiss')
          },
        }),
      )
    })
  }
}

export default useAwaitConfirmation
